import { Box, Card, CardContent, Typography, Button, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Grid, Chip } from '@mui/material';
import { Download, Print, CheckCircle, Cancel } from '@mui/icons-material';
import { reportePCTA } from '../billingData';

const ReportPCTA = () => {
  const data = reportePCTA;

  return (
    <Box>
      {/* Header */}
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
        <Box>
          <Typography variant="h5" component="h1" gutterBottom>
            Declaración de Compras - F14
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Formulario de Declaración de Compras de Persona Natural
          </Typography>
        </Box>
        <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
          <Chip 
            icon={data.sujetoExcluido ? <CheckCircle /> : <Cancel />} 
            label={data.sujetoExcluido ? 'Sujeto Excluido' : 'No Sujeto Excluido'} 
            color={data.sujetoExcluido ? 'success' : 'warning'}
          />
          <Button variant="outlined" startIcon={<Print />}>
            Imprimir
          </Button>
          <Button variant="contained" startIcon={<Download />} color="primary">
            Exportar PDF
          </Button>
        </Box>
      </Box>

      {/* Periodo */}
      <Card sx={{ mb: 3, backgroundColor: '#fff3e0' }}>
        <CardContent sx={{ textAlign: 'center' }}>
          <Typography variant="h4" color="warning.main">
            {data.periodo}
          </Typography>
        </CardContent>
      </Card>

      <Grid container spacing={3}>
        {/* Detalle de Compras */}
        <Grid item xs={12}>
          <Card>
            <CardContent>
              <Typography variant="h6" gutterBottom sx={{ borderBottom: '2px solid #f57c00', pb: 1 }}>
                DETALLE DE COMPRAS
              </Typography>
              
              <TableContainer>
                <Table>
                  <TableHead>
                    <TableRow sx={{ backgroundColor: '#f5f5f5' }}>
                      <TableCell sx={{ fontWeight: 'bold' }}>#</TableCell>
                      <TableCell sx={{ fontWeight: 'bold' }}>Proveedor</TableCell>
                      <TableCell sx={{ fontWeight: 'bold' }}>NIT</TableCell>
                      <TableCell sx={{ fontWeight: 'bold' }} align="right">Monto</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {data.compras.map((compra, index) => (
                      <TableRow key={index} sx={{ '&:hover': { backgroundColor: '#fafafa' } }}>
                        <TableCell>{index + 1}</TableCell>
                        <TableCell>{compra.proveedor}</TableCell>
                        <TableCell>{compra.nit}</TableCell>
                        <TableCell align="right">${compra.monto.toFixed(2)}</TableCell>
                      </TableRow>
                    ))}
                    <TableRow sx={{ backgroundColor: '#fff3e0', fontWeight: 'bold' }}>
                      <TableCell colSpan={3} sx={{ fontWeight: 'bold' }}>TOTAL COMPRAS</TableCell>
                      <TableCell align="right" sx={{ fontWeight: 'bold' }}>${data.totalCompras.toFixed(2)}</TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </TableContainer>
            </CardContent>
          </Card>
        </Grid>

        {/* Resumen */}
        <Grid item xs={12}>
          <Card sx={{ backgroundColor: '#e8f5e9' }}>
            <CardContent>
              <Typography variant="h6" gutterBottom>
                Resumen de Declaración
              </Typography>
              <Grid container spacing={2}>
                <Grid item xs={12} md={6}>
                  <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
                    <Typography>Total Compras del Período</Typography>
                    <Typography sx={{ fontWeight: 600 }}>${data.totalCompras.toFixed(2)}</Typography>
                  </Box>
                </Grid>
                <Grid item xs={12} md={6}>
                  <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
                    <Typography>Tipo de Declarante</Typography>
                    <Chip 
                      label={data.sujetoExcluido ? 'Sujeto Excluido' : 'Persona Natural'} 
                      size="small"
                      color={data.sujetoExcluido ? 'success' : 'primary'}
                    />
                  </Box>
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        </Grid>
      </Grid>

      {/* Info */}
      <Card sx={{ mt: 3, backgroundColor: '#f5f5f5' }}>
        <CardContent>
          <Typography variant="h6" gutterBottom>
            Declaración de Compras - Formulario F14
          </Typography>
          <Typography variant="body2">
            El formulario F14 es utilizado por personas naturales para declarar sus compras realizadas en el período fiscal.
            Este formulario es requerido para la declaración de renta de personas naturales y muestra todas las adquisiciones
            de bienes y servicios realizadas.
          </Typography>
        </CardContent>
      </Card>
    </Box>
  );
};

export default ReportPCTA;
